import { Toastify } from '@client/core/components/react/Toastify';
import { react2angular } from 'react2angular';

export const AngularToastify = react2angular(Toastify);
